export default "__VITE_ASSET__BJjX1pbp__"